import {ComponentProps} from 'react';

import {RoundButton} from '@optimaxdev/design-system';

import s from './customerAddresses.scss';

/**
 * get props for RoundButton depends on oneStep checkout
 */
export const getButtonProps = (isRedesigned: boolean) => {
    const buttonProps: Partial<ComponentProps<typeof RoundButton>> = {
        className: isRedesigned ? s.redesignedButton : s.button,
        colorName: 'geyser',
        isFull: true,
        size: isRedesigned ? 'small' : 'extraSmall',
        variant: 'painted',
    };

    return buttonProps;
};
